// extracted by mini-css-extract-plugin
export var headerBoxShadow = "header-module--header-box-shadow--xv13v";